"use client";
import useFormSubmit from "@/hooks/useApiSubmit";
import { useAppDispatch } from "@/store/hooks";
import { setNameAndMessage } from "@/store/features/appSlice";
import { Button, Field, Fieldset, Form, PhoneField, TextArea } from "@repo/ui";
import { useRouter } from "next/navigation";
import * as Yup from "yup";
import TermsCheckbox from "./TermsCheckbox";
import { useCountryCode } from "@/hooks/useCountryCode";

const QueryFormSchema = Yup.object().shape({
  fullName: Yup.string()
    .required()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Full name field is required"),
  contactNumber: Yup.string()
    .required()
    .min(10, "Too Short!")
    .max(16, "Too Long!")
    .required("Phone filed is required"),
  email: Yup.string()
    .email("Invalid email")
    .required("Email id field is required"),
});

export type CorporateTrainingPackageFormProps = {
  packageName?: string;
  onSuccess?: () => void;
};

const CorporateTrainingPackageForm = ({
  packageName,
  onSuccess,
}: CorporateTrainingPackageFormProps) => {
  const DEFAULT_FORM_VALUES = {
    fullName: "",
    contactNumber: "",
    email: "",
    message: "",
    preferredOption: packageName || "starter",
    enquiryType: "CORPORATE_TRAINING_PACKAGE_FORM",
    terms: "false",
  };
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { country } = useCountryCode();
  const { handleSubmit } = useFormSubmit({
    onSuccess: (data) => {
      dispatch(setNameAndMessage(data.response));
      if (onSuccess) {
        onSuccess();
      }
      // Redirect to thank you page
      router.push("/thank-you-for-enquiry");
    },
  });

  return (
    <Form
      initialValues={DEFAULT_FORM_VALUES}
      validationSchema={QueryFormSchema}
      onSubmit={handleSubmit}
      className="mt-6 p-1"
    >
      {({ values, handleChange, setFieldValue, isSubmitting }) => (
        <>
          <Fieldset>
            <Field
              name="fullName"
              label="Full Name"
              required
              value={values.fullName}
              onChange={handleChange}
            />
            <PhoneField
              label="Phone Number"
              name="contactNumber"
              required
              value={values.contactNumber}
              onChange={(phone: string) =>
                setFieldValue("contactNumber", phone)
              }
              defaultCountry={country}
            />
            <Field
              label="Email ID"
              required
              name="email"
              value={values.email}
              onChange={handleChange}
            />
            <TextArea
              name="message"
              label="Message"
              required
              colSpan={2}
              value={values.message}
              placeholder="Type your message here..."
              onChange={handleChange}
            />
          </Fieldset>

          <TermsCheckbox
            onCheckedChange={(value) => setFieldValue("terms", value)}
            value={values.terms}
          />

          <div className="text-right mt-4">
            <Button type="submit" color="primary" loading={isSubmitting}>
              Submit
            </Button>
          </div>
          {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
        </>
      )}
    </Form>
  );
};

export default CorporateTrainingPackageForm;
